<template>
  <div class="online-pay-setting" id="onlinePaySetting">
    <second-menu-link-content>
      <template v-slot:header>
        <span>在线支付</span>
      </template>
      <template v-slot:content>
        <div class="title">第三方支付</div>
        <div class="container">
          <div class="card-container">
            <div class="row alipay-logo">
              <div class="edit-btn-container">
                <div class="edit-btn" @click="_showAlipayAccountForm()"></div>
              </div>
            </div>
            <div class="row desc-container">
              <div class="desc">需开通企业支付宝账号，仅支持以企业对公账号作为收款账户。交易手续费由支付宝公司向收款方收取。</div>
              <div v-show="onlinePaymentIsOpen" class="status">已开通</div>
              <div v-show="!onlinePaymentIsOpen" class="status">未开通</div>
            </div>
          </div>
          <div class="weChat-container">
            <div class="row alipay-logo">
              <div class="edit-btn-container">
                <div class="edit-btn" @click="_showWeChatAccountForm()"></div>
              </div>
            </div>
            <div class="row desc-container">
              <div class="desc">需开通企业微信商户号，仅支持以企业对公账号作为 收款账户。交易手续费由微信公司向收款方收取。</div>
              <div v-show="weChatOnlinePaymentIsOpen" class="status">已开通</div>
              <div v-show="!weChatOnlinePaymentIsOpen" class="status">未开通</div>
            </div>
          </div>
        </div>
        <el-dialog title="修改支付宝信息" width="440px" :visible.sync="dialogAlipayAccountFormVisible">
          <el-form
            :model="alipayAccountForm"
            :rules="alipayAccountFormRules"
            ref="alipayAccountForm"
            label-position="right"
            label-width="110px"
          >
            <el-form-item label="状态：" prop="status">
              <el-radio-group v-model="alipayAccountForm.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="APPID：" prop="Pid">
              <el-input class="gray" v-model="alipayAccountForm.Pid"></el-input>
            </el-form-item>
            <el-form-item label="支付宝公钥：" prop="payerPublicKey">
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5}"
                class="gray"
                v-model="alipayAccountForm.payerPublicKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="开发者私钥：" prop="developerPrivateKey">
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5}"
                class="gray"
                v-model="alipayAccountForm.developerPrivateKey"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="btn-white" @click="resetForm('alipayAccountForm')">取 消</el-button>
            <el-button class="btn-blue" @click="submitForm('alipayAccountForm')">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="修改微信信息" width="440px" :visible.sync="dialogWeChatAccountFormVisible">
          <el-form
            :model="weChatAccountForm"
            :rules="weChatAccountFormRules"
            ref="weChatAccountForm"
            label-position="right"
            label-width="110px"
          >
            <el-form-item label="状态：" prop="status">
              <el-radio-group v-model="weChatAccountForm.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="APPID：" prop="Pid">
              <el-input class="gray" v-model="weChatAccountForm.Pid"></el-input>
            </el-form-item>
            <el-form-item label="商户号：" prop="payerPublicKey">
              <el-input class="gray" v-model="weChatAccountForm.payerPublicKey"></el-input>
            </el-form-item>
            <el-form-item label="密钥：" prop="developerPrivateKey">
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5}"
                class="gray"
                v-model="weChatAccountForm.developerPrivateKey"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="btn-white" @click="weChatResetForm('weChatAccountForm')">取 消</el-button>
            <el-button class="btn-blue" @click="weChatSubmitForm('weChatAccountForm')">确 定</el-button>
          </div>
        </el-dialog>
        <div class="title" v-if="internetBankingData.length>0">网银支付</div>
        <div class="internet-banking">
          <div class="card" v-for="(value,index) in internetBankingData" :key="index">
            <p class="edit-btn" @click="openDialogInternetBanking(value)"></p>
            <p class="cart-status">
              <span v-if="value.status === 0">未开通</span>
              <span v-if="value.status === 1">已开通</span>
            </p>
          </div>
          <el-dialog
            @close="closeDialog"
            width="440px"
            title="网银设置"
            :visible.sync="dialogInternetBankingVisible"
          >
            <el-form
              :model="internetBankingForm"
              ref="internetBankingForm"
              :rules="internetBankingFormRules"
              label-position="right"
              label-width="90px"
            >
              <el-form-item label="状态：" prop="status">
                <el-radio-group v-model="internetBankingForm.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="appId：" prop="appId">
                <el-input class="white" v-model="internetBankingForm.appId"></el-input>
              </el-form-item>
              <el-form-item label="secret：" prop="secret">
                <el-input class="white" v-model="internetBankingForm.secret"></el-input>
              </el-form-item>
              <el-form-item label="商户代码：" prop="merchantCode">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  class="gray"
                  v-model="internetBankingForm.merchantCode"
                ></el-input>
              </el-form-item>
              <el-form-item label="商户私钥：" prop="merchantPrivateKey">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  class="gray"
                  v-model="internetBankingForm.merchantPrivateKey"
                ></el-input>
              </el-form-item>
              <el-form-item label="PFX证书：" prop="file">
                <el-upload
                  action="#"
                  :limit="1"
                  :auto-upload="false"
                  :before-remove="beforeRemove"
                  :on-change="onChange"
                  :file-list="file"
                  :class="!internetBankingForm.file && file.length===0?'':'upload'"
                >
                  <el-button
                    class="btn-upload"
                    size="mini"
                    v-if="!internetBankingForm.file && file.length===0"
                  >点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="btn-white" @click="closeInternetBankingDialog">取 消</el-button>
              <el-button class="btn-blue" @click="submitInternetBanking">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBSiteSet from "models/db/site-set.js";
const dbSiteSet = new DBSiteSet();
export default {
  data() {
    return {
      // 线上支付宝支付是否开通
      onlinePaymentIsOpen: 0,
      weChatOnlinePaymentIsOpen: 0,
      addOrUpdate: "update",
      weChatAddOrUpdate: "update",
      dialogAlipayAccountFormVisible: false,
      dialogWeChatAccountFormVisible: false,
      dialogInternetBankingVisible: false,
      alipayAccountForm: {
        status: 0,
        Pid: "",
        payerPublicKey: "",
        developerPrivateKey: ""
      },
      alipayAccountFormRules: {
        status: {
          required: true
        },
        Pid: {
          required: true,
          message: "请填写合作伙伴身份",
          trigger: true
        },
        payerPublicKey: {
          required: true,
          message: "请填写支付者公钥",
          trigger: true
        },
        developerPrivateKey: {
          required: true,
          message: "请填写开发者私钥",
          trigger: true
        }
      },
      weChatAccountForm: {
        status: 0,
        Pid: "",
        payerPublicKey: "",
        developerPrivateKey: ""
      },
      weChatAccountFormRules: {
        status: {
          required: true
        },
        Pid: {
          required: true,
          message: "请填写合作伙伴身份",
          trigger: true
        },
        payerPublicKey: {
          required: true,
          message: "商户号",
          trigger: true
        },
        developerPrivateKey: {
          required: true,
          message: "密钥",
          trigger: true
        }
      },
      // 文件上传暂存
      file: [],
      postWeChatParamOnlinePay: 1,
      // 网银数据
      internetBankingData: [],
      internetBankingForm: {
        status: 0,
        merchantCode: "",
        file: "",
        merchantPrivateKey: "",
        appId: "",
        secret: ""
      },
      postWeChatParamOnlinePay: 1,
      internetBankingFormRules: {
        status: {
          required: true
        },
        merchantCode: {
          required: true,
          message: "请填写商户代码",
          trigger: true
        },
        file: {
          required: true,
          message: "请添加证书",
          trigger: true
        },
        merchantPrivateKey: {
          required: true,
          message: "请填写私钥密码",
          trigger: true
        },
        appId: {
          required: true,
          message: "请填写appId",
          trigger: true
        },
        secret: {
          required: true,
          message: "请填写secret",
          trigger: true
        }
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this._hideAlipayAccountForm();
          let data;
          if (this.addOrUpdate === "update") {
            data = {
              id: this.postParamId,
              onlinePay: this.postParamOnlinePay,
              appId: this.alipayAccountForm.Pid,
              status: this.alipayAccountForm.status,
              privateKey: this.alipayAccountForm.developerPrivateKey,
              publicKey: this.alipayAccountForm.payerPublicKey
            };
          } else if (this.addOrUpdate === "add") {
            data = {
              onlinePay: this.postParamOnlinePay,
              appId: this.alipayAccountForm.Pid,
              status: this.alipayAccountForm.status,
              privateKey: this.alipayAccountForm.developerPrivateKey,
              publicKey: this.alipayAccountForm.payerPublicKey
            };
          }
          this._updateDBSiteOnlinePayInfo(data);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    weChatSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this._hideWeChatAccountForm();
          let data;
          if (this.weChatAddOrUpdate === "update") {
            data = {
              id: this.postWeChatParamId,
              onlinePay: this.postWeChatParamOnlinePay,
              appId: this.weChatAccountForm.Pid,
              status: this.weChatAccountForm.status,
              privateKey: this.weChatAccountForm.developerPrivateKey,
              publicKey: this.weChatAccountForm.payerPublicKey
            };
          } else if (this.weChatAddOrUpdate === "add") {
            data = {
              onlinePay: this.postWeChatParamOnlinePay,
              appId: this.weChatAccountForm.Pid,
              status: this.weChatAccountForm.status,
              privateKey: this.weChatAccountForm.developerPrivateKey,
              publicKey: this.weChatAccountForm.payerPublicKey
            };
          }
          this._updateDBSiteOnlinePayInfo(data);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this._hideAlipayAccountForm();
    },
    weChatResetForm(formName) {
      this._hideWeChatAccountForm();
    },
    // 显示网银弹窗
    openDialogInternetBanking(value) {
      this.dialogInternetBankingVisible = true;
      this.internetBankingForm.status = value.status;
      this.internetBankingForm.merchantCode = value.merchantCode;
      this.internetBankingForm.merchantPrivateKey = value.merchantPrivateKey;
      this.internetBankingForm.appId = value.appId;
      this.internetBankingForm.secret = value.secret;
      this.internetBankingForm.file = {
        fileName: value.file
      };
      this.file = [
        {
          name: value.file
        }
      ];
    },
    // 网银证书上传
    onChange(file, fileList) {
      this.internetBankingForm.file = file.raw;
    },
    // 网银证书删除
    beforeRemove() {
      this.file = [];
      this.internetBankingForm.file = "";
    },
    //
    closeDialog() {
      this.file = [];
    },
    // 关闭网银弹窗
    closeInternetBankingDialog() {
      this.dialogInternetBankingVisible = false;
    },
    // 上传网银弹窗
    submitInternetBanking() {
      this.$refs.internetBankingForm.validate(valid => {
        if (valid) {
          let status = this.internetBankingForm.status;
          let merchantID = this.internetBankingForm.merchantCode;
          let file = this.internetBankingForm.file;
          let merchantCertPassword = this.internetBankingForm
            .merchantPrivateKey;
          let appId = this.internetBankingForm.appId;
          let secret = this.internetBankingForm.secret;
          let formData = new FormData();
          formData.append("status", status);
          if (!file.fileName) {
            formData.append("file", file);
          }
          formData.append("merchantID", merchantID);
          formData.append("merchantCertPassword", merchantCertPassword);
          formData.append("appId", appId);
          formData.append("secret", secret);
          dbSiteSet.postInternetBanking(formData).then(res => {
            console.log(res);
            if (res.success) {
              this.dialogInternetBankingVisible = false;
              this._getDBSiteOnlinePayInfo();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    _showAlipayAccountForm() {
      this.dialogAlipayAccountFormVisible = true;
    },
    _showWeChatAccountForm() {
      this.dialogWeChatAccountFormVisible = true;
    },
    _hideAlipayAccountForm() {
      this.dialogAlipayAccountFormVisible = false;
    },
    _hideWeChatAccountForm() {
      this.dialogWeChatAccountFormVisible = false;
    },
    _getDBSiteOnlinePayInfo() {
      dbSiteSet
        .getDBSiteOnlinePayInfo()
        .then(res => {
          if (res.success) {
            console.log("线上支付信息--", res.result);
            // 获取支付宝支付信息
            if (res.result.online.length > 0) {
              res.result.online.map(item => {
                if (item.onlinePay === 0) {
                  let {
                    id,
                    onlinePay,
                    status,
                    appId,
                    privateKey,
                    publicKey
                  } = item;
                  this.alipayAccountForm.status = status;
                  this.alipayAccountForm.Pid = appId;
                  this.alipayAccountForm.payerPublicKey = publicKey;
                  this.alipayAccountForm.developerPrivateKey = privateKey;
                  this.onlinePaymentIsOpen = status;
                  this.postParamId = id;
                  this.postParamOnlinePay = onlinePay;
                  this.addOrUpdate = "update";
                }
                if (item.onlinePay === 1) {
                  let {
                    id,
                    onlinePay,
                    status,
                    appId,
                    privateKey,
                    publicKey
                  } = item;
                  this.weChatAccountForm.status = status;
                  this.weChatAccountForm.Pid = appId;
                  this.weChatAccountForm.payerPublicKey = publicKey;
                  this.weChatAccountForm.developerPrivateKey = privateKey;
                  this.weChatOnlinePaymentIsOpen = status;
                  this.postWeChatParamId = id;
                  this.postWeChatParamOnlinePay = onlinePay;
                  this.weChatAddOrUpdate = "update";
                }
              });
            } else {
              // 为空
              this.onlinePaymentIsOpen = 0;
              this.weChatOnlinePaymentIsOpen = 0;
              this.alipayAccountForm = {
                status: 0,
                Pid: "",
                payerPublicKey: "",
                developerPrivateKey: ""
              };
              this.weChatAccountForm = {
                status: 0,
                Pid: "",
                payerPublicKey: "",
                developerPrivateKey: ""
              };
              this.addOrUpdate = "add";
              this.weChatAddOrUpdate = "add";
            }
            // 获取网银信息
            if (res.result["E-currency"].length > 0) {
              let arr = [];
              res.result["E-currency"].map(value => {
                let obj = {};
                obj.type = value.type;
                obj.status = value.status;
                obj.merchantCode = value.merchantID;
                obj.file = value.fileName;
                obj.merchantPrivateKey = value.merchantCertPassword;
                obj.appId = value.appId;
                obj.secret = value.secret;
                arr.push(obj);
              });
              this.internetBankingData = arr;
            }
          }
        })
        .catch(e => {
          console.log("线上支付信息异常--", e);
        });
    },
    _updateDBSiteOnlinePayInfo(data) {
      dbSiteSet
        .updateDBSiteOnlinePayInfo(data)
        .then(res => {
          if (res.success) {
            console.log("更新成功--", res);
            this.$message({
              type: "success",
              center: true,
              message: "保存成功！",
              duration: 2000
            });
            this._getDBSiteOnlinePayInfo();
          } else {
            console.log("更新失败--");
            this.$message({
              type: "error",
              center: true,
              message: "保存失败！",
              duration: 2000
            });
          }
        })
        .catch(e => {
          console.log("更新异常--", e);
        });
    }
  },
  created() {
    this._getDBSiteOnlinePayInfo();
  },
  components: {
    SecondMenuLinkContent
  }
};
</script>

<style lang="scss" scoped>
.online-pay-setting {
  width: 100%;
  height: 100%;
  .title {
    height: 32px;
    background: rgba(245, 247, 250, 1);
    border-radius: 8px 8px 0px 0px;
    margin-bottom: 20px;
    font-size: 16px;
    padding-left: 6px;
    line-height: 32px;
  }
  .container {
    display: flex;
    justify-content: flex-start;
  }
  .card-container,
  .weChat-container {
    margin-bottom: 20px;
    width: 320px;
    height: 160px;
    display: flex;
    flex-direction: column;
    .row {
      box-sizing: border-box;
      height: 50%;
    }
    .alipay-logo {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      .edit-btn-container {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        padding-top: 6px;
        padding-right: 12px;
        justify-content: flex-end;
        .edit-btn {
          width: 16px;
          height: 16px;
          padding: 2px;
          background-size: 16px 16px;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url("../../../../assets/offline-pay/edit.png");
          cursor: pointer;
        }
      }
    }
    .desc-container {
      padding: 10px 24px 14px 24px;
      position: relative;
      .desc {
        line-height: 16px;
        font-size: 12px;
        color: #606266;
      }
      .status {
        font-size: 12px;
        color: rgba(61, 116, 242, 1);
        position: absolute;
        bottom: 12px;
        right: 34px;
      }
    }
  }
  .card-container {
    background-image: url("../../../../assets/online-pay/zfb_logo_bg.png");
    background-size: cover;
    background-repeat: no-repeat;
  }
  .weChat-container {
    box-sizing: border-box;
    margin-left: 20px;
    padding: 4px 0px;
    .alipay-logo {
      background-image: url("../../../../assets/online-pay/weChat_logo_bg.png");
      background-repeat: no-repeat;
      background-position:center;
      background-color: #40AF40;
    }
    .desc-container {
      box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
      border-radius: 0px 0px 8px 8px;
    }
  }
  .internet-banking {
    display: flex;
    .card {
      width: 320px;
      height: 120px;
      border-radius: 8px;
      background: url("../../../../assets/online-pay/agricultural-bank.png")
        center no-repeat #00947e;
      background-size: 230px;
      position: relative;
      .edit-btn {
        position: absolute;
        width: 16px;
        height: 16px;
        padding: 2px;
        background-size: 16px 16px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("../../../../assets/offline-pay/edit.png");
        cursor: pointer;
        right: 6px;
        top: 2px;
      }
      .cart-status {
        position: absolute;
        color: #fff;
        font-size: 12px;
        bottom: 8px;
        right: 30px;
      }
    }
  }
}
</style>

<style lang="scss">
#onlinePaySetting {
  .el-form {
    width: 380px;
    .el-form-item {
      margin-bottom: 20px;
      /* .el-form-item__label {
        text-align: left;
      } */
      .upload {
        .el-upload {
          display: inline;
        }
      }
    }
    .el-form-item.is-required {
      flex-direction: column;
      /* .el-form-item__label {
        display: flex;
        justify-content: flex-start;
      } */
    }
  }
  .el-input {
    .el-input__inner {
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 420px;
      .el-dialog__header {
        box-sizing: border-box;
        width: 100%;
        .el-dialog__title {
          font-weight: 550;
        }
      }
      .el-dialog__body {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        justify-content: center;
        .btn-upload {
          height: 22px;
          font-size: 12px;
          width: 64px;
          padding: 0;
        }
      }
      .el-dialog__footer {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        justify-content: space-around;
      }
    }
  }
}
</style>
